import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-bee10ab8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "iframe-wrap"
};
var _hoisted_2 = ["src"];
import { ref, reactive, getCurrentInstance, onMounted } from "vue";
import { useRoute } from "vue-router";
export default {
  __name: 'Iframe',
  setup: function setup(__props) {
    var route = useRoute();
    var query = route.query;
    var instance = getCurrentInstance();
    var src = ref(query.src);
    var title = ref(query.title);
    var themeVars = reactive({
      navBarIconColor: "#323232",
      navBarTitleFontSize: "17px"
    });
    var goBack = function goBack() {
      instance.proxy.$xsyxBridge.popBack();
    };
    var forbidBack = function forbidBack() {
      var isBlock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      instance.proxy.$xsyxBridge.shouldBlockPopGesture({
        isBlock: isBlock
      });
    };
    var navHeight = ref("");
    onMounted(function () {
      navHeight.value = window.deviceInfo.statusBarHeight;
      forbidBack();
      setTimeout(function () {
        instance.proxy.$vconsole.destroy();
      }, 0);
    });
    return function (_ctx, _cache) {
      var _component_van_nav_bar = _resolveComponent("van-nav-bar");
      var _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_config_provider, {
        "theme-vars": themeVars
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_nav_bar, {
            onClickLeft: goBack,
            fixed: "",
            style: _normalizeStyle({
              'padding-top': navHeight.value + 'px'
            }),
            "left-arrow": "",
            title: title.value
          }, null, 8, ["style", "title"])];
        }),
        _: 1
      }, 8, ["theme-vars"]), _createElementVNode("iframe", {
        class: "iframe",
        src: src.value,
        style: {
          'margin-top': 40 + 'px'
        }
      }, null, 8, _hoisted_2)]);
    };
  }
};